import React, { useState, useEffect } from 'react';

const ApplicationJobInfoForm = ({ initialData = {}, onNext, onBack }) => {
  const [jobTitle, setJobTitle] = useState(initialData.title || '');
  const [companyTitle, setCompanyTitle] = useState(initialData.company_title || '');

  useEffect(() => {
    setJobTitle(initialData.title || '');
    setCompanyTitle(initialData.company_title || '');
  }, [initialData]);

  const handleNext = () => {
    onNext({
      title: jobTitle || null,
      company_title: companyTitle || null,
    });
  };

  return (
    <div className="card-style-1">
      <div className="row">
        <div className="col-md-6 mb-30">
          <label className="form-label">Job Title (optional)</label>
          <input
            className="form-control"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            placeholder="e.g., Frontend Engineer"
          />
        </div>
        <div className="col-md-6 mb-30">
          <label className="form-label">Company (optional)</label>
          <input
            className="form-control"
            value={companyTitle}
            onChange={(e) => setCompanyTitle(e.target.value)}
            placeholder="e.g., JobFlow Connect"
          />
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-border" onClick={onBack}>
          Back
        </button>
        <button type="button" className="btn btn-default" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default ApplicationJobInfoForm;


